import React, { useState, useEffect, useContext } from 'react';
import { string, shape } from 'prop-types';
import { ExperienceContext, useStore, useMVCSID } from '@thd-nucleus/experience-context';
import { withErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { withDynamicComponent } from '@thd-nucleus/app-render';
import { withHydrator } from '@thd-olt-component-react/hydrator';

import { makeApiRequest } from '../../utils/requestHelpers';
import { hasValidPipData } from '../../utils/helpers';
import './SponsoredPipBanner.scss';
import { initImpressionWatchers } from '../../utils/initImpressionWatchers';
import useFbtSkuListener from '../../utils/useFbtSkuListener';
import { bannerTypes } from '../../constants/constants';

const SponsoredPipBannerComponent = (props) => {
  const [hasData, setHasData] = useState(false);
  const experienceContext = useContext(ExperienceContext);
  let { pageContext } = props;
  const browserId = useMVCSID();
  const schema = 'pip_sponsored';
  const schemaId = `${schema}__banner_${pageContext.data.treatment}`;
  const { fbtSkus } = useFbtSkuListener(pageContext?.data?.itemId);

  const maxWidth = experienceContext.channel === 'desktop' ? '100%' : '450px';
  const { storeId, isLocalized } = useStore({
    varnish: true,
    online: true
  });

  experienceContext.useStoreId = storeId;

  useEffect(() => {
    const isResolvedContext = experienceContext.mounted;

    if (hasValidPipData(pageContext, fbtSkus) && isResolvedContext && browserId) {
      makeApiRequest({
        browserId,
        schema,
        schemaId,
        experienceContext,
        pageContext,
        setHasData,
        bannerType: bannerTypes.MIDDLE,
        eventBusData: { fbtSkus }
      });
    } else {
      setHasData(false);
    }
  }, [fbtSkus, experienceContext.mounted, browserId]);

  useEffect(() => {
    initImpressionWatchers();
  }, [hasData]);

  return (hasData && (
    <div
      data-component="SponsoredPipBanner"
      className="sponsored_pip_banner_container"
      style={{ maxWidth }}
    >
      <div id={schemaId} data-testid="sponsored-pip-banner" className="sponsored_pip_banner" />
    </div>
  ));
};

const propTypes = {
  pageContext: shape({
    label: string,
    treatment: string,
    data: shape({
      itemId: Number
    })
  })
};

const defaultProps = {
  pageContext: {}
};

SponsoredPipBannerComponent.propTypes = propTypes;
SponsoredPipBannerComponent.defaultProps = defaultProps;

const HydratedSponsoredPipBanner = withHydrator({
  id: 'hydrated-sponsored-pip-banner',
  className: 'sponsored-pip-banner-hydrator',
  scrollBuffer: 100
}, SponsoredPipBannerComponent);

const DynamicSponsoredPipBanner = withDynamicComponent(HydratedSponsoredPipBanner);
const SponsoredPipBanner = withErrorBoundary(DynamicSponsoredPipBanner);

SponsoredPipBanner.propTypes = propTypes;
SponsoredPipBanner.defaultProps = defaultProps;
SponsoredPipBanner.displayName = 'SponsoredPipBanner';

export { SponsoredPipBannerComponent, SponsoredPipBanner };
